import { Button } from "../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../components/generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";
import { SearchBar } from "../../components/generic/SearchBar";
import { useState } from "react";
import { UserItem } from "../../components/users/UserItem";
import { RoleItem } from "../../components/roles/RolesItem";
import AddRoleModal from "../../components/users/AddRole";

const Roles = () => {
  const rolepicked = usePickerhook();
  const [entered, setentered] = useState("");
  const [showaddrole, setshowaddrole] = useState(false);

  const roles = [1, 2, 3, 4];

  const onChange = (e: string) => {
    setentered(e);
  };

  return (
    <div className="w-full pr-20  flex  ">
      {showaddrole && <AddRoleModal show={setshowaddrole} />}

      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Roles ({roles.length})
          </p>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add Role
              </>
            }
            onBtnClick={() => {
              setshowaddrole(true);
            }}
          />
        </div>
        <div className="w-full flex justify-between items-center mb-2">
          <SearchBar placeholder="Search" onchange={onChange} value={entered} />
        </div>
        <hr />

        <div className="grid grid-cols-2 mt-4 gap-6">
          {roles.map(() => (
            <RoleItem />
          ))}
        </div>
      </div>
    </div>
  );
};
export { Roles };
